import {
  AggregationQuery,
  MeasurementPoint,
  Query
} from '@/components/AnalyticsDashboard/measurements/contracts'
import { postRequestGateway } from '@/services/api.service'

export async function fetchAggregate(
  query: AggregationQuery,
  signal?: AbortSignal
): Promise<MeasurementPoint[]> {
  const endpoint = `/aggregate/v1/measurements/aggregate`
  return (await postRequestGateway<MeasurementPoint[]>(endpoint, query, signal)).data
}

export async function fetchInformation(
  query: Query,
  signal?: AbortSignal
): Promise<MeasurementPoint[]> {
  const endpoint = `/aggregate/v1/measurements/information`
  return (await postRequestGateway<MeasurementPoint[]>(endpoint, query, signal)).data
}
